import httpUtil from "@/utils/httpUtil";

export const exportStack = params => httpUtil.get("/stack/export", params);
